import { t as tr, locale } from '../i18n'
// Every time of the chosen day: green = free (pick it), red = already taken
// (shown so customers see the day's real shape, but not selectable).
export default function TimeSlotPicker({ slots = [], value, onChange, timeZone, loading, emptyMessage }) {
  if (loading) {
    return (
      <div className="slot-grid" aria-busy="true">
        {Array.from({ length: 9 }, (_, i) => <span key={i} className="slot is-loading" />)}
      </div>
    )
  }
  if (!slots.length) {
    return <p className="rounded-xl bg-stone-50 p-4 text-slate-600">{emptyMessage || tr("No times on this day. Choose another date.")}</p>
  }
  const freeCount = slots.filter(s => s.status === 'available').length
  const fmt = t => new Date(t).toLocaleTimeString(locale(), { hour: '2-digit', minute: '2-digit', timeZone: timeZone || undefined })
  return (
    <div>
      <p className="text-xs text-slate-500 mb-2">{freeCount} {tr("of")} {slots.length} {tr("times available")}</p>
      <div className="slot-grid" role="listbox" aria-label={tr("Available times")}>
        {slots.map(slot => {
          const booked = slot.status !== 'available'
          const selected = value === slot.time
          return (
            <button
              key={slot.time}
              type="button"
              role="option"
              aria-selected={selected}
              disabled={booked}
              aria-label={`${fmt(slot.time)}${booked ? ', booked' : ', available'}`}
              onClick={() => onChange(slot.time)}
              className={`slot ${booked ? 'is-booked' : 'is-available'}${selected ? ' is-selected' : ''}`}
            >
              <span className="slot-time">{fmt(slot.time)}</span>
              {booked && <small>{tr("Booked")}</small>}
            </button>
          )
        })}
      </div>
      <div className="avail-legend" aria-hidden="true">
        <span><i className="is-available" />{tr("Available")}</span>
        <span><i className="is-full" />{tr("Booked")}</span>
      </div>
    </div>
  )
}
